import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Button,
  Input,
  Row,
  Col,
  Popconfirm,
  Space,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import deleteDataById from "../../../hooks/deleteDataById";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import axios from "../../../components/utils/Interceptors";

const { Title } = Typography;

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

const AllCoupon = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [filterText, setFilterText] = useState("");
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const getAllCoupons = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APIURL}/vendor/getallcoupon`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        const result = await response.data;
        if (result.status_code === 200 && result.data) {
          setCoupons(result.data);
        }
      } catch (err) {
        toast.error("Failed to load coupons");
      }
    };

    getAllCoupons();
  }, []);

  const filteredItems = coupons.filter(
    (item) =>
      item.coupon_code &&
      item.coupon_code.toLowerCase().includes(filterText.toLowerCase())
  );

  const handleDelete = async (id) => {
    setLoading(true);
    const response = await deleteDataById("vendor/deletecoupon", id);
    if (response.status_code === 200) {
      setCoupons((prev) => prev.filter((item) => item.coupon_id !== id));
      toast.success(t("Deleted successfully"));
    } else {
      toast.error(t("something went wrong"));
    }
    setLoading(false);
  };

  const handleEdit = (id) => {
    navigate("/vendor/edit_coupon", {
      state: id,
    });
  };

  const columns = [
    {
      title: t("coupon_code"),
      dataIndex: "coupon_code",
      key: "coupon_code",
    },
    {
      title: t("coupon_type"),
      dataIndex: "coupon_type",
      key: "coupon_type",
    },
    {
      title: t("Minimum Purchase Amount"),
      dataIndex: "minimum_purchase_amount",
      key: "minimum_purchase_amount",
    },
    {
      title: t("Discount"),
      dataIndex: "maximum_discount",
      key: "maximum_discount",
    },
    {
      title: t("coupon_st_date"),
      dataIndex: "from_date",
      key: "from_date",
      render: (text) => formatDate(text),
    },
    {
      title: t("coupon_end_date"),
      dataIndex: "to_date",
      key: "to_date",
      render: (text) => formatDate(text),
    },
    {
      title: t("vd_pc_C_Options"),
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record.coupon_id)}
            type="default"
          />
          <Popconfirm
            title={t("delete_alert_title")}
            description={t("delete_alert_des")}
            onConfirm={() => handleDelete(record.coupon_id)}
            okText={t("yes")}
            cancelText={t("no")}
            okButtonProps={{
              style: { backgroundColor: '#F4900C', borderColor: '#F4900C' } // Red button
            }}
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={3}>{t("coupon_al_c")}</Title>
        </Col>
        <Col>
          <Link to="/vendor/add-coupon">
            {/* <Button type="primary" icon={<PlusOutlined />}>
              {t("coupon_al_add_c")}
            </Button> */}
            <button
              className="btn btn-primary w-full rounded-md text-white"
            >
              {t("coupon_al_add_c")}
            </button>
          </Link>
        </Col>
      </Row>

      <Row style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={8}>
          <Input
            placeholder={t("Search by coupon code")}
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            allowClear
          />
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={filteredItems}
        rowKey="coupon_id"
        loading={loading}
        pagination={{ pageSize: 10 }}
        locale={{
          emptyText: <h4 style={{ color: "#999" }}>{t("No records")}</h4>,
        }}
        scroll={{ x: "max-content" }}
      />
    </>
  );
};

export default AllCoupon;
